module.exports = __webpack_public_path__ + "img/reject-uppercase.31d20ad2.svg";